/*************************************************/
/* IMAGE-SLIDER                                  */
/*************************************************/
import Swiper, { Navigation, Pagination,Autoplay } from 'swiper';

export function imageSlider() {

    const init = function () {

        const swiper = new Swiper('.swiper', {
            modules: [Navigation, Pagination,Autoplay],
            loop: true,
            centeredSlides:true,
            autoplay: {delay:3000},
            speed: 500,
            pagination: {
                el: ".image-slider__slider-pagination"
            },
            navigation: {
                nextEl: ".image-slider__slider-next",
                prevEl: ".image-slider__slider-prev",
            }
        });
    }

    init();
}

